import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  Inject,
  OnInit,
  signal,
} from '@angular/core';
import { ModalHeaderComponent } from '../../../molecules/modal/modal-header/modal-header.component';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent } from '@angular/material/dialog';
import { CheckInService } from '../../../../services/check-in.service';
import { ModalService } from '../../../../services/modal.service';
import { User } from '../../../../types/user.types';
import { compact } from 'lodash-es';

@Component({
  selector: 'app-modal-show-checked-in-users',
  imports: [ModalHeaderComponent, MatDialogContent],
  templateUrl: './modal-show-checked-in-users.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalShowCheckedInUsersComponent implements OnInit {
  static overlayDataType: { activityId: string };

  private readonly users = signal<User[]>([]);

  private readonly checkInService = inject(CheckInService);

  readonly sortedUsers = computed(() =>
    this.users().sort((a, b) => (a.lastname > b.lastname ? 1 : -1))
  );

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: typeof ModalShowCheckedInUsersComponent.overlayDataType
  ) {}

  ngOnInit(): void {
    this.getCheckedInUsers();
  }

  private getCheckedInUsers(): void {
    this.checkInService.getAllCheckInsByActivityId(this.data.activityId).subscribe({
      next: (response) => this.users.set(response.payload.users),
    });
  }
}
